import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NavigationEvent} from './datepicker-view-model';
import {FishDate} from './fish-date';
import {FishDatepickerI18n} from './datepicker-i18n';
import {FishCalendar} from './fish-calendar';


export class FishDatepickerNavigation {
  navigation = NavigationEvent;

   date: FishDate;
   disabled: boolean;
   maxDate: FishDate;
   minDate: FishDate;
   months: number;
   showSelect: boolean;
   showWeekNumbers: boolean;

   navigate = new EventEmitter<NavigationEvent>();
   select = new EventEmitter<FishDate>();

  constructor(public i18n: FishDatepickerI18n, private _calendar: FishCalendar) {}

  doNavigate(event: NavigationEvent) { this.navigate.emit(event); }

  nextDisabled() {
    return this.disabled || (this.maxDate && this._calendar.getNext(this.date, 'm').after(this.maxDate));
  }

  prevDisabled() {
    const prevDate = this._calendar.getPrev(this.date, 'm');
    return this.disabled || (this.minDate && prevDate.year <= this.minDate.year && prevDate.month < this.minDate.month);
  }

  selectDate(date: FishDate) { this.select.emit(date); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'fish-datepicker-navigation',
  host: {'class': 'd-flex justify-content-between', '[class.collapsed]': '!showSelect'},
  styles: [`
    :host {
      height: 2rem;
      line-height: 1.85rem;
    }
    :host.collapsed {
      margin-bottom: -2rem;        
    }
    .fish-dp-navigation-chevron::before {
      border-style: solid;
      border-width: 0.2em 0.2em 0 0;
      content: '';
      display: inline-block;
      height: 0.75em;
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
      -ms-transform: rotate(-135deg);
      width: 0.75em;
      margin: 0 0 0 0.5rem;
    }    
    .fish-dp-navigation-chevron.right:before {
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      margin: 0 0.5rem 0 0;
    }
    .btn-link {
      cursor: pointer;
      outline: 0;
    }
    .btn-link[disabled] {
      cursor: not-allowed;
      opacity: .65;
    }    
  `],
  template: `
    <button type="button" class="btn-link" (click)="!!doNavigate(navigation.PREV)" [disabled]="prevDisabled()">
      <span class="fish-dp-navigation-chevron"></span>    
    </button>
    
    <fish-datepicker-navigation-select *ngIf="showSelect" class="d-block" [style.width.rem]="months * 9"
      [date]="date"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [disabled] = "disabled"
      (select)="selectDate($event)">
    </fish-datepicker-navigation-select>
    
    <button type="button" class="btn-link" (click)="!!doNavigate(navigation.NEXT)" [disabled]="nextDisabled()">
      <span class="fish-dp-navigation-chevron right"></span>
    </button>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FishDatepickerI18n, },
{type: FishCalendar, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'date': [{ type: Input },],
'disabled': [{ type: Input },],
'maxDate': [{ type: Input },],
'minDate': [{ type: Input },],
'months': [{ type: Input },],
'showSelect': [{ type: Input },],
'showWeekNumbers': [{ type: Input },],
'navigate': [{ type: Output },],
'select': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
